export class Pays {

    public static getPaysInconnu(code: string): Pays {
        let pays = new Pays();
        let libCode;
        if (code != null) {
            libCode = ' [code=' + code + ']';
        } else {
            libCode = ' [code=null]';
        }
        pays.code =  code;
        pays.pays =  'Inconnu' + libCode;
        pays.paysEn = 'UNKNOWN' + libCode;
        pays.edition =  'Inconnu';
        pays.nationalite =  'Inconnu';
        return pays ;
    }

    constructor(
        public code?: string,
        public pays?: string,
        public paysEn?: string,
        public edition?: string,
        public nationalite?: string,
        public isEuropeens?: boolean

) { }




}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/pays.model.ts